import store from "../app/store";
import { createAction } from "@reduxjs/toolkit";
import { showDangerToast } from "../validation/ToastContainer";
import { ACTION_DEVICE_CHANGELOG_LOADED } from "./change-details/ChangeDetailsPageReducer";
import { securedFetch } from "../auth/authService";
import { RULE_CHANGELOG_API, VALIDATION_RESULT_API } from "../vars";
import { getSortAndFilterQueryString } from "../view/urlService";
import { ACTION_CHANGELOG_LIST_LOADED } from "./details/DeviceDetailsPageReducer";


export function listPageable(pageNumber, pageSize, deviceId, msbId) {

    let queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    queryString += `&f_devicePk=${deviceId}&f_realTime=0`;
    
    if (msbId) {
        queryString +=`&f_msbPk=${msbId}`
    }
    

    return securedFetch(`${VALIDATION_RESULT_API}/page?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_CHANGELOG_LIST_LOADED)({ changelogList: data.page, pageNumber, totalPages: data.total }))
            //return {changelogList: data.page, pageNumber, totalPages: data.total};
            return { changelogList: data.page, totalPages: data.total, pageNumber, totalRecords: data.records };
        })
}

export function listPageable_o(pageNumber, pageSize, deviceId) {

    let queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    queryString += `&f_devicePk=${deviceId}&f_realTime=0`;   

    return securedFetch(`${VALIDATION_RESULT_API}/page?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_CHANGELOG_LIST_LOADED)({ changelogList: data.page, pageNumber, totalPages: data.total }))
            //return {changelogList: data.page, pageNumber, totalPages: data.total};
            return { changelogList: data.page, totalPages: data.total, pageNumber, totalRecords: data.records };
        })
}

export function loadById(id) {
    return securedFetch(`${RULE_CHANGELOG_API}/${id}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_DEVICE_CHANGELOG_LOADED)({ changelog: data }))
        }).catch(err => {
            showDangerToast(err, "Error");
        });
}
